var React = require('react');

function VideoControlsPauseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"5","y":"5","width":"3.33333","height":"14","key":0}),React.createElement("rect",{"x":"15.666","y":"5","width":"3.33333","height":"14","key":1})]));
}

VideoControlsPauseInline.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = VideoControlsPauseInline;

VideoControlsPauseInline.default = VideoControlsPauseInline;
